import { create } from 'zustand';
import type { User } from 'firebase/auth';
import type { UserDoc } from '../types/domain';

interface AuthState {
  authUser: User | null;
  userDoc: UserDoc | null;
  loading: boolean;
  setAuthUser: (user: User | null) => void;
  setUserDoc: (userDoc: UserDoc | null) => void;
  setLoading: (loading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  authUser: null,
  userDoc: null,
  loading: true,
  setAuthUser: (user) => set({ authUser: user }),
  setUserDoc: (userDoc) => set({ userDoc }),
  setLoading: (loading) => set({ loading }),
  clearAuth: () => set({ authUser: null, userDoc: null, loading: false }),
}));
